import { ActiveStatus } from "models/enumerations/active-status/active-status";
import { Topic } from "models/enumerations/courses/topic";
import { TrainingType } from "models/enumerations/courses/training-type";
import { Language } from "models/enumerations/languages/language";
import { ProductRecord } from "models/view-models/products/product-record";
import { createContext, useContext } from "react";

export interface ProductSearchCriteria {
  searchText: string;
  associatedProducts: ProductRecord[];
  productType: TrainingType | undefined;
  language?: Language;
  topic?: Topic;
  availableForAEN: boolean;
  status: ActiveStatus[];
  currentPage: number;
};

export interface ProductSearchContextParams {
    initialCriteria: ProductSearchCriteria;
    setCriteria: React.Dispatch<React.SetStateAction<ProductSearchCriteria>>;
}

const defaultProductSearchCriteria: ProductSearchCriteria = {
  searchText: "",
  associatedProducts: [],
  productType: undefined,
  language: undefined,
  topic: undefined,
  availableForAEN: false,
  status: [ActiveStatus.Active],
  currentPage: 1,
};

const ProductSearchContext = createContext<ProductSearchContextParams>({
    initialCriteria: defaultProductSearchCriteria,
    setCriteria: () => {},
});

const useProductSearch = () => {
  return useContext(ProductSearchContext);
};

export { ProductSearchContext, useProductSearch, defaultProductSearchCriteria };

// #endregion Exports
